import React from "react";
import { Image } from "react-bootstrap";
import { HistoryAndCommentLoader } from "../../component/LoadersTemplate";
import LoaderTemplate from "../../component/LoaderTemplate";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import IssueActivityHistory from "../issueDetail/IssueActivityHistory";
import NoComments from "../../assets/no_comments.png";

export default ({ isLoading, data, template, getAllComments, MarginTop }) => {
  const dataToIterate = data
    ? isValidArray(data.filter(value => isValidArray(value)))
    : [];
  console.log(dataToIterate);
  const commentList = [];
  let commentExists = false;
  if (isValidArray(dataToIterate)) {
    dataToIterate.forEach(data => {
      data.forEach(comment => {
        if (!comment.isAutomated) {
          commentList.push(comment);
        }
        if (comment.isAutomated && !comment.isChildIssueComment) {
          commentList.push(comment);
        }
      });
    });
    commentList.sort(function(x, y) {
      return y.date - x.date;
    });
    commentExists = true;
  }
  return (
    <div className="history-activity-content">
      {isLoading === STATUS.LOADING ? (
        <LoaderTemplate
          height={80}
          width={300}
          children={<HistoryAndCommentLoader />}
        />
      ) : (
        (commentExists ? (
          <div className="issue-comments-section">
            {commentList.map(comment => (
              <div key={comment.date}>
                <IssueActivityHistory
                  pendingComments={comment.status == "PENDING"}
                  approvedBy={comment.approvedBy}
                  modifiedBy={comment.modifiedDate}
                  history={comment}
                  type="comment"
                  getAllComments={getAllComments}
                  buttonVisibility={true}
                  MarginTop={MarginTop}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">
            <Image
              src={NoComments}
              alt="No comments"
              className="no-comments-image"
            />
          </div>
        )) || null
      )}
    </div>
  );
};
